<h2 id="propertiesTransferred">Informations sur les enfants</h2>

<div class="d-flex">
  <magieno-boolean-select
          [advancedFormControl]="incomeTaxPersonalForm.formElements.isCareExpensesCalculated | asAdvancedFormControl"></magieno-boolean-select>
</div>

<div class="row">
  @for (childForm of this.children.formGroups; track childForm; let i = $index) {
  <div class="col-12 col-md-6">
    <div class="card mt-4">
      <div class="row card-body">
        <div class="row d-flex justify-content-between">
          <div class="d-flex" style="width: fit-content">
            <h3 [id]="'enfant-' + (i + 1)">Enfant #{{ i + 1 }}</h3>
          </div>
          <div class="dropdown d-flex" style="width: fit-content">
            <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
               data-expanded="false" href="#" role="button">
              <i class="fe fe-more-vertical"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <a (click)="removeChild(i); $event.preventDefault()" class="dropdown-item"
                 href="#">
                Supprimer
              </a>
            </div>
          </div>
        </div>
        <app-salary-dividend-personal-tax-child-form #property [childForm]="childForm" [form]="this.form"
                                                     [index]="i"></app-salary-dividend-personal-tax-child-form>
      </div>
    </div>
  </div>
  }

  <div class="col-12 col-md-6">
    <div class="card mt-4">
      <div class="card-body d-flex align-items-center" style="height:400px;">
        <button (click)="this.addChild();" class="btn btn-link stretched-link flex-fill text-center" href="#add_child"
           id="add_child">
          + Ajouter un enfant
        </button>
      </div>

    </div>
  </div>
</div>


